import React, { useState } from "react";
import styles from "./DadachainIntro.module.css";
import { BiNews, BiChevronDown, BiChevronUp } from "react-icons/bi";
import dadachainImage from "../../assets/images/dadachain.PNG";
import newsList from "../../data/newsData";

const DadachainIntro = () => {
  const [openNews, setOpenNews] = useState(null);

  const toggleNews = (id) => {
    setOpenNews(openNews === id ? null : id);
  };

  return (
    <section className={styles.introSection}>
      <a href="https://dadachain.xyz" target="_blank" rel="noopener noreferrer">
        <img
          src={dadachainImage}
          alt="Dadachain Main"
          className={styles.mainImage}
        />
      </a>

      <div className={styles.newsContainer}>
        {newsList.map((news) => (
          <div key={news.id} className={styles.newsItem}>
            <div
              className={styles.newsHeader}
              onClick={() => toggleNews(news.id)}
            >
              <div className={styles.newsTitle}>
                <BiNews className={styles.newsIcon} />
                {news.title}
              </div>
              {openNews === news.id ? (
                <BiChevronUp className={styles.chevronIcon} />
              ) : (
                <BiChevronDown className={styles.chevronIcon} />
              )}
            </div>

            {openNews === news.id && (
              <div className={styles.newsContent}>
                {/* HTML 태그 적용 */}
                <div dangerouslySetInnerHTML={{ __html: news.content }} />
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default DadachainIntro;
